import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { TAG } from '../../../constants/queryKeys';
import tagApiV2 from '../../../lib/api/tag/TagApiV2';
import { GetTagListRequest } from '../../../lib/api/tag/type';
import { QueryOptions } from '../../../types/query/useQuery';
import { TagsFindResponseBodyDto } from '../../../types/api/tags';

type UseTagListQueryArgsType<SelectResultType> = {
  payload: GetTagListRequest;
  options?: QueryOptions<TagsFindResponseBodyDto, unknown, SelectResultType>;
};
export const useTagList = <SelectResultType>({
  payload,
  options,
}: UseTagListQueryArgsType<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<TagsFindResponseBodyDto, unknown, SelectResultType>(
    [...TAG.LIST, payload],
    (): Promise<TagsFindResponseBodyDto> => tagApiV2.getTagList(payload),
    {
      ...options,
    },
  );
};
export default useTagList;
